export default class TriggerPasswordResetRequest {
    username: string;
}